<template>
<div>
  <a :style="'font-weight:bold;'+(window.width<480 ? 'font-size:10px;': 'font-size:12px;')">
    {{
      $tc(
        "sondage.nbReponses_au_sondage",
        this.$store.state.sondage.nbr_reponses_au_sondage,
        { count: this.$store.state.sondage.nbr_reponses_au_sondage }
      )
    }}
  </a>
  </div>
</template>

<script>
export default {
  name: 'NbParticipantsButton',
  props: {
    window: {
      required: true
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/resultats/components/NbParticipants.vue